/* eslint-disable id-blacklist */

import Hashids from "hashids";

/**
 * Import:
 *     import "@extensiones/NumberExtension";
 *
 * Uso:
 *     const hash = 15.encode("clave")
 */

declare global {
    interface Number {
        encode(clave: string): string;
    }
}

Number.prototype.encode = function(clave: string) {
    return new Hashids(clave).encode(this);
};
